<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on }">
    <v-list-item v-ripple @click="open" class="list__menu-item">
        <v-list-item-title class="list__menu-text">
          <v-img :src="require('@/assets/img/icons/trash.svg')"></v-img>
          <span>Delete</span>
        </v-list-item-title>
      </v-list-item>
    </template>

    <v-card>
      <div class="delete-confirmation">
        <v-card-title>
          <h2 class="dialog-card__header">Delete community</h2>
        </v-card-title>
        <v-form>
          <v-card-text class="dialog-card__message">
            <h3>Are you sure you want to delete
              <span class="name">{{name}}</span>?</h3>
            <slot name="additional_info"></slot>
          </v-card-text>
          <v-card-actions class="btn-container">
            <v-btn class="custom-btn custom-btn--see-through"
                   color="secondary" @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn class="custom-btn" color="secondary"
                   @click="deleteCommunity">
              Delete
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
      props: ["name"],
      data: () => ({
          dialog: false
      }),
      methods: {
          deleteCommunity () {
              this.$emit("delete")
              this.dialog = false
          },
          open () {
              setTimeout(() => this.dialog = true);
              this.$emit("opened");
          }
      }
  }
</script>
